module.exports = __webpack_public_path__ + "img/powerOutage.94637f44.svg";